// Library Import
import {useEffect, useState, useRef} from 'react';
import {Form, Alert} from 'react-bootstrap';
import Proptypes from 'prop-types';

// File Import
import uploadIcon from '~/images/icon/upload.png';
import CrossIcon from '~/images/icon/cross-gray.png';
import LoadingGif from '~/images/common/loading.gif';
import {PostApi} from '@/http';

export const AddNewPost = ({handleChange, handleRemovePost, getImageFullPath, errors, itemIndex, postIndex, item}) => {
    const [serverError, setServerError] = useState('');
    const [isUploading, setIsUploading] = useState(false);
    const [imagePath, setImagePath] = useState(null);
    const fileUploadRef = useRef(null);

    useEffect(() => {
        if (item.image_full_path !== undefined) setImagePath(item.image_full_path);
    }, [item]);

    /**
     * Open upload file
     * @param {*} event 
     * @returns 
     */
    const handleFileChange = (event) => {
        event.preventDefault();
        const { files } = event.currentTarget;
        if (!files || !files[0]) return;
        handleUploadImage(files);
    }

    /**
     * Drop upload file
     * @param {*} event 
     */
    const handleFileDrop = (event) => {
        event.preventDefault();
        if ((!event.dataTransfer) || (!event.dataTransfer.files || !event.dataTransfer.files[0])) return;
        handleUploadImage(event.dataTransfer.files);
    }

    const handleUploadImage = async (fileData) => {
        const formData = new FormData();

        if (fileData) formData.append('image', fileData[0]);
        setIsUploading(true);
        setServerError();
        try {
            const response = await PostApi.uploadImage(formData);
            if (response.status === 200) {
                setImagePath(response.data.data.original_url);
                setServerError('');
                getImageFullPath(response.data.data.original_url, itemIndex, postIndex);
                setTimeout(() => {
                    setIsUploading(false);
                }, 1000);
                handleChange(
                    {
                        target: {
                            name: 'image',
                            value: response.data.data.image_url
                        }
                    },
                    itemIndex,
                    postIndex
                );
            }
        } catch (error) {
            setIsUploading(false);
            if (error.response.status === 422) {
                setServerError(error.response.data.message);
            } else {
                setServerError('Server error occured !');
            }
        }
    };

    const handleRemoveImage = (event) => {
        event.stopPropagation();
        setImagePath(null);
        handleChange(
            {
                target: {
                    name: 'image',
                    value: ''
                }
            },
            itemIndex,
            postIndex
        );
    };

    return (
        <div className='multi-post mb-3'>
            {postIndex > 0 && (
                <div className='remove-item'>
                    <img onClick={() => handleRemovePost(itemIndex, postIndex)} src={CrossIcon} alt='Cross Icon'/>
                </div>
            )}
            {/* Title Input */}
            <Form.Group className='mb-3' controlId={`post_new_title_${itemIndex}${postIndex}`}>
                <Form.Label>
                    コンテンツタイトル<span className='is-required'>*</span>
                </Form.Label>
                <Form.Control
                    name='title'
                    onChange={(event) => handleChange(event, itemIndex, postIndex)}
                    type='text'
                    placeholder='ご記入ください'
                    value={item?.title ? item?.title : ''}
                    isInvalid={errors?.title}
                />
                <Form.Control.Feedback type='invalid'>{errors?.title}</Form.Control.Feedback>
            </Form.Group>
            {/* Description */}
            <Form.Group className='mb-3' controlId={`post_new_description_${itemIndex}${postIndex}`}>
                <Form.Label>
                    コンテンツ本文<span className='is-required'>*</span>
                </Form.Label>
                <Form.Control
                    onChange={(event) => handleChange(event, itemIndex, postIndex)}
                    type='text'
                    name='description'
                    as='textarea'
                    rows={3}
                    placeholder='ご記入ください'
                    value={item?.description ? item?.description : ''}
                    isInvalid={errors?.description}
                />
                <Form.Control.Feedback type='invalid'>{errors?.description}</Form.Control.Feedback>
            </Form.Group>

            {/* Image upload */}
            <Form.Group className='mb-2' controlId={`upload_main_image_new_${itemIndex}_${postIndex}`}>
                <Form.Label>
                    イメージアップロード <span className='is-required'>*</span>
                    <span className='is-allowed'>PNG,JPG & GIF files are allowed</span>
                </Form.Label>
                <div className={errors?.image ? 'form-file is-invalid' : 'form-file'} onDragOver={handleFileDrop} onDrop={handleFileDrop} onClick={() => fileUploadRef?.current?.click()}>
                    <input id={`upload_main_image_new_${itemIndex}_${postIndex}`} type='file' hidden onChange={(event) => handleFileChange(event)} ref={fileUploadRef} accept='image/png, image/gif, image/jpeg' />
                    <div className='file-content'>
                        {imagePath !== null ? (
                            <div className='preview-content'>
                                <img src={imagePath} alt='Header Image'/>
                            </div>
                        ) : (
                            <>
                                <img src={uploadIcon} alt='Upload Icon'/>
                                <span>クリックして画像を追加</span>
                            </>
                        )}
                    </div>
                    {isUploading && (
                        <div className='upload-image'>
                            <img src={LoadingGif} style={{width: '170px'}} alt='Loading Image'/>
                        </div>
                    )}

                    {/* Remove upload image */}
                    {imagePath !== null && !isUploading && (
                        <div className='remove-item remove-image'>
                            <img onClick={handleRemoveImage} src={CrossIcon} alt='Cross Icon'/>
                        </div>
                    )}
                </div>

                <Form.Control.Feedback type='invalid'>{errors?.image}</Form.Control.Feedback>
                <div className='error-message text-start pt-2' style={{fontSize: '13px'}}>
                    {serverError}
                </div>
            </Form.Group>
        </div>
    );
};

AddNewPost.prototype = {
    handleChange: Proptypes.func,
    itemIndex: Proptypes.number,
    postIndex: Proptypes.number,
    handleRemovePost: Proptypes.func,
    getImageFullPath: Proptypes.func,
    item: Proptypes.object,
    errors: Proptypes.object
};
